export default "__VITE_ASSET__BQcToTBl__"